import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminCriteriaList from "@/features/criteria/components/admin/AdminCriteriaList";
import { useCriteriaPermissions } from "@/pages/admin/criteria";

export const Route = createFileRoute("/app/admin/criteria/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllCriteria, userCanViewAllCriteria } = useCriteriaPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Criteria", link: "/app/admin/criteria" },
        ]}
      />
      <h1>Criterion Management</h1>
      <p>
        <Button
          disabled={!userCanEditAllCriteria}
          color="primary"
          component={Link}
          to={`/app/admin/criteria/new`}
          variant="contained"
          size="small"
        >
          Add Criterion
        </Button>
      </p>
      <AdminCriteriaList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllCriteria={userCanViewAllCriteria}
      />
    </>
  );
}
